import DefaultLink from '@/components/common/default/DefaultLink';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import { Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { BiSearchAlt } from 'react-icons/bi';

export default function HeaderEmptyHits({
  searchOnFocus,
  searchValue,
}: {
  searchOnFocus: boolean;
  searchValue: string;
}) {
  const { translate } = useTypedTranslation<CommonEnum>('common');

  return (
    <Transition
      show={
        searchOnFocus && searchValue?.trim().length > 0 && !(window as any)?.searchResults?.length
      }
      enter="tw-transition tw-ease-out tw-duration-200"
      enterFrom="tw-opacity-0 tw-translate-y-1"
      enterTo="tw-opacity-100 tw-translate-y-0"
      leave="tw-transition tw-ease-in tw-duration-150"
      leaveFrom="tw-opacity-100 tw-translate-y-0"
      leaveTo="tw-opacity-0 tw-translate-y-1"
      as={Fragment}
    >
      <div className="tw-mt-1 tw-overflow-hidden tw-rounded-md tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5">
        <div className="tw-bg-white tw-px-6 tw-py-8">
          <div className="tw-text-center">
            <div className="tw-mx-auto tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100">
              <BiSearchAlt className="tw-h-6 tw-w-6 tw-text-gray-400" />
            </div>

            <h3 className="tw-mt-3 tw-text-base tw-font-medium tw-text-gray-900">
              {translate(CommonEnum['no_results_found'] || 'No results found')}
            </h3>

            <p className="tw-mx-auto tw-mt-2 tw-max-w-sm tw-text-sm tw-text-gray-500">
              {translate(CommonEnum['no_results_description_search_term']).replace(
                '{{searchTerm}}',
                searchValue
              )}
            </p>

            <div className="tw-mt-6 tw-flex tw-items-center tw-justify-center">
              <DefaultLink
                href="/search"
                className="tw-inline-flex tw-items-center tw-text-sm tw-font-medium tw-text-indigo-600 hover:tw-text-indigo-500"
              >
                {translate(CommonEnum['browse_all_spirits'])}
                <span aria-hidden="true"> &rarr;</span>
              </DefaultLink>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
}
